import { render, staticRenderFns } from "./Microplatform.vue?vue&type=template&id=3b3d4a8e&scoped=true&"
var script = {}
import style0 from "./Microplatform.vue?vue&type=style&index=0&id=3b3d4a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3d4a8e",
  null
  
)

export default component.exports